export const subHeaderProps = {
    color: "text.subheader",
    fontWeight: "bold",
    variant: "h6",
};
